import moment from 'jalali-moment';

export const timeFromCreated = (createdAt: string) => {
  const today = new Date();
  const dateTime = moment(moment(createdAt)).locale('fa').from(today);
  return dateTime;
};
export const CodeToInputGroupName: {[key: number]: string} = {
  11: 'fertilizer',
  12: 'pesticide',
  13: 'seed',
  14: 'employee',
  15: 'machinery',
  16: 'tool',
  17: 'farm',
  18: 'lab',
};
